<app-menu-bar/>
<div class="dashboard-block !pt-2">
  @if(!isLoading()) {
    <app-list-thingies
      class="w-full justify-center items-center"
      [groupByExperimentChecked]="groupByExperimentChecked"
      [refreshListSignal]="refreshListSignal"
      [viewMode]="viewMode"
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [(selectedTab)]="selectedThingieTab"
    ></app-list-thingies>
  }
</div>
